import { render, staticRenderFns } from "./staff-info.vue?vue&type=template&id=b1155ad8&scoped=true&"
import script from "./staff-info.vue?vue&type=script&lang=js&"
export * from "./staff-info.vue?vue&type=script&lang=js&"
import style0 from "./staff-info.vue?vue&type=style&index=0&id=b1155ad8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1155ad8",
  null
  
)

export default component.exports